import api from './client.js'

export const nasAPI = {
  browseSharedFiles: (path = '') => api.get(`/nas/files/browse?path=${encodeURIComponent(path)}`),
  downloadSharedFile: (path) => api.get(`/nas/files/download?path=${encodeURIComponent(path)}`, { responseType: 'blob' }),
  downloadSharedFolder: (path) => api.get(`/nas/files/download-folder?path=${encodeURIComponent(path)}`, { responseType: 'blob' }),
  getSharedCacheInfo: () => api.get('/nas/files/cache-info'),
  precacheSharedFolder: (path) => api.post(`/nas/files/precache?path=${encodeURIComponent(path)}`),
  clearSharedCache: (path) => api.delete(`/nas/files/clear-cache?path=${encodeURIComponent(path)}`),

  browseGames: (path = '') => api.get(`/nas/games/browse?path=${encodeURIComponent(path)}`),
  downloadGameFile: (path) => api.get(`/nas/games/download?path=${encodeURIComponent(path)}`, { responseType: 'blob' }),
  downloadGameFolder: (path) => api.get(`/nas/games/download-folder?path=${encodeURIComponent(path)}`, { responseType: 'blob' }),
  getCacheInfo: () => api.get('/nas/games/cache-info'),
  precacheGame: (path) => api.post(`/nas/games/precache?path=${encodeURIComponent(path)}`),
  clearGameCache: (path) => api.delete(`/nas/games/clear-cache?path=${encodeURIComponent(path)}`),

  getMediaFolders: () => api.get('/nas/media/folders'),
  createMediaFolder: (name) => api.post('/nas/media/folders', { name }),
  toggleMediaFolder: (id) => api.patch(`/nas/media/folders/${id}/toggle`),
  deleteMediaFolder: (id) => api.delete(`/nas/media/folders/${id}`),

  listMediaFiles: (folderId) => api.get(`/nas/media/folders/${folderId}/files`),
  uploadMediaFile: (folderId, file) => {
    const form = new FormData()
    form.append('file', file)
    return api.post(`/nas/media/folders/${folderId}/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  downloadMediaFile: (folderId, filename) =>
    api.get(`/nas/media/folders/${folderId}/download?filename=${encodeURIComponent(filename)}`, { responseType: 'blob' }),
  previewMediaFileUrl: (folderId, filename) =>
    `/api/nas/media/folders/${folderId}/preview?filename=${encodeURIComponent(filename)}`,
  deleteMediaFile: (folderId, filename) =>
    api.delete(`/nas/media/folders/${folderId}/files?filename=${encodeURIComponent(filename)}`),
}
